interface GoogleBreadcrumbsList {
  '@context': 'https://schema.org'
  '@type': 'BreadcrumbList'
  itemListElement: GoogleItemListElement[]
}

interface GoogleItemListElement {
  '@type': 'ListItem'
  position: number
  url?: string
  name?: string
  item?: string
}

interface GoogleBreadcrumbsListJsonProps {
  items: {
    name: string
    item: string | undefined
    position: number
  }[]
}

export function GoogleBreadcrumbsListJson(props: GoogleBreadcrumbsListJsonProps) {
  const { items } = props

  const jsonLdSchema: GoogleBreadcrumbsList = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map(item => {
      const data: GoogleItemListElement = {
        '@type': 'ListItem',
        position: item.position,
        name: item.name,
      }

      if (item.item) {
        data.item = item.item
      }

      return data
    }),
  }

  return (
    <script
      key="google-breacrumbs-list-structured-data"
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdSchema) }}
    />
  )
}
